import { render } from "./HeroAuthLeaveDashboard.vue?vue&type=template&id=5882320a&scoped=true"
import script from "./HeroAuthLeaveDashboard.vue?vue&type=script&lang=js"
export * from "./HeroAuthLeaveDashboard.vue?vue&type=script&lang=js"

import "./HeroAuthLeaveDashboard.vue?vue&type=style&index=0&id=5882320a&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5882320a"]])

export default __exports__